import { defer } from './defer';
export function iif(condition, trueResult, falseResult) {
    return defer(function () { return (condition() ? trueResult : falseResult); });
}
//# sourceMappingURL=iif.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/dist/esm5/internal/observable/iif.js
// module id = 1190
// module chunks = 0